<template>
  <b-container class="bg-white py-4">
    <b-row v-if="!permissionAdd">
      <b-col>
        <b-card>
          <h4>You do not have access permission for this page</h4>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="permissionAdd">
      <b-col>
        <b-container>
          <b-row class="mb-4" v-if="firststep">
            <b-col>
              <h4>Adding new external source</h4>
              <div class="mb-2"><strong>Source title</strong></div>
                <b-form-input   id="titleInput"
                                v-model="row.name"
                                placeholder="Source tile"
                                required
                                class="mb-2">
                </b-form-input>
              <div class="mb-2"><strong>Comments and context (markdown)</strong></div>
                <b-form-textarea id="detailsInput"
                                v-model="row.comments"
                                placeholder="Comments"
                                required
                                rows=4
                                class="mb-2">
                </b-form-textarea>
              <div class="mb-2"><strong>Link</strong></div>
                <b-form-input   id="linkInput"
                                v-model="row.link"
                                placeholder="Link"
                                required
                                class="mb-2">
                </b-form-input>
                <b-button v-if="validate" class="mr-2" variant="primary" size="sm" v-on:click="preview">Preview</b-button>
                <b-button variant="outline-primary" size="sm" :to="{ name: 'Risks' }">Cancel</b-button>
            </b-col>
          </b-row>
          <b-row class="mb-4" v-if="previewstep">
            <b-col>
              <h4>{{row.name}}</h4>
              <markdown :content="row.comments" />
              <div>link: <a href="row.link" target="_blank">{{row.link}}</a></div>
              <span v-if="!saving">
                <b-button v-if="validate" class="mr-2" variant="primary" size="sm" v-on:click="save">Save</b-button>
                <b-button variant="outline-primary" size="sm" v-on:click="edit">Edit</b-button>
              </span>
                <span v-if="saving"><i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i></span>
            </b-col>
          </b-row>
          <b-row class="mb-4" v-if="finalstep">
            <b-col>
              <h4>Created: {{row.name}}</h4>
              <markdown :content="row.comments" />
              <div>link: <a href="row.link" target="_blank">{{row.link}}</a></div>
              <b-button variant="primary" size="lg" :to="{ name: 'ExtsourceEdit', params: { id: row.id }}">Continue to edit details</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Markdown from '@/components/Markdown.vue'
import ac from '../libs/accesscontrol'

export default {
  name: 'ExtsourceAdd',
  beforeDestroy () {},
  components: {
    Markdown
  },
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    },
    validate: function () {
      return this.row.name && this.row.comments && this.row.link
    }
  },
  created: function () {
    this.permissionAdd = ac.can(this.user.acgroups).createAny('extsource').granted
  },
  data () {
    return {
      firststep: true,
      finalstep: false,
      permissionAddRisk: false,
      previewstep: false,
      saving: false,
      rendered: {
        comments: null
      },
      row: {
        name: null,
        comments: null,
        link: null
      }
    }
  },
  methods: {
    edit: function () {
      this.firststep = true
      this.previewstep = false
      this.finalstep = false
    },
    preview: function () {
      this.firststep = false
      this.finalstep = false
      this.previewstep = true
    },
    save: async function () {
      this.$logger.debug(`save start`)
      this.previewstep = false
      this.saving = true
      try {
        // let response = await this.$http(config)
        let apiName = 'cosmos'
        let path = `/extsource`
        let params = {
          body: {
            row: this.row
          }
        }
        let response = await this.$Amplify.API.put(apiName, path, params)
        this.$logger.debug('saved OK:', response)
        this.row = response
        this.finalstep = true
      } catch (e) {
        this.$logger.warn('row saving error: ' + e)
      }
      this.saving = false
    }
  },
  mounted () {},
  watch: {}
}
</script>

<style>
</style>
